import { useState } from "react";
import SearchableMultiUserSelect from "./SearchableMultiUserSelect";

export default function ScheduleTicketModal({
  open,
  onClose,
  onSubmit,
  users = [],
  ukTime = false,
}) {
  const [startAt, setStartAt] = useState("");
  const [duration, setDuration] = useState(60);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [notifyRequester, setNotifyRequester] = useState(false);

  if (!open) return null;

  const toggleUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id)
        ? prev.filter((u) => u !== id)
        : [...prev, id]
    );
  };

  const handleSubmit = () => {
    onSubmit({
      start_at: startAt,
      duration_minutes: duration,
      assignee_ids: selectedUsers,
      notify_requester: notifyRequester,
    });
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white w-[420px] rounded-lg shadow-lg p-4">
        <h2 className="text-lg font-semibold mb-4">Schedule Ticket</h2>

        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium block mb-1">
              Start date & time{ukTime ? " (UK time)" : ""}
            </label>
            <input
              type="datetime-local"
              className="w-full border rounded px-2 py-1"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
          </div>

          <div>
            <label className="text-sm font-medium block mb-1">
              Duration (minutes)
            </label>
            <input
              type="number"
              className="w-full border rounded px-2 py-1"
              value={duration}
              onChange={(e) => setDuration(Number(e.target.value))}
            />
          </div>

          <div>
            <label className="text-sm font-medium block mb-1">
              Assign users
            </label>

            <SearchableMultiUserSelect
              users={users}
              value={selectedUsers}
              onChange={setSelectedUsers}
              placeholder="Search technicians..."
            />
          </div>

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={notifyRequester}
              onChange={(e) => setNotifyRequester(e.target.checked)}
            />
            Notify requester
          </label>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            className="px-3 py-1 bg-gray-300 rounded"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="px-3 py-1 bg-blue-600 text-white rounded"
            onClick={handleSubmit}
          >
            Schedule
          </button>
        </div>
      </div>
    </div>
  );
}